import { schema } from "normalizr";

const UserAccountSchema = new schema.Entity("userAccounts");
const UserAccountArraySchema = new schema.Array(UserAccountSchema);

export { UserAccountSchema, UserAccountArraySchema };